import { TruckStatus } from "../types/truck";

export const getAvailableNextStatuses = (currentStatus: TruckStatus): TruckStatus[] => {
  switch (currentStatus) {
    case TruckStatus.ON_WORK:
      return [TruckStatus.STANDBY, TruckStatus.MAINTENANCE];
    case TruckStatus.STANDBY:
      return [TruckStatus.ON_WORK, TruckStatus.MOB, TruckStatus.MAINTENANCE];
    case TruckStatus.MAINTENANCE:
      return [TruckStatus.STANDBY, TruckStatus.ON_WORK];
    case TruckStatus.MOB:
      return [TruckStatus.ON_WORK, TruckStatus.MOB, TruckStatus.STANDBY, TruckStatus.MAINTENANCE];
    case TruckStatus.UNKNOWN:
      return [TruckStatus.ON_WORK, TruckStatus.MOB, TruckStatus.STANDBY, TruckStatus.MAINTENANCE];
    case TruckStatus.RETIRED:
      return [TruckStatus.STANDBY];
    default:
      return [];
  }
};

export const isStatusTransitionValid = (
  fromStatus: TruckStatus,
  toStatus: TruckStatus,
): boolean => {
  const availableNextStatuses = getAvailableNextStatuses(fromStatus);
  return availableNextStatuses.includes(toStatus);
};
